import { createElementObject, createOverlayComponent } from './core';
// import { Tooltip as LeafletTooltip } from '@anlan/gs-map';
import { useEffect } from 'react';
import type { ReactNode } from 'react';
import L from '@anlan/gs-map';
import type { LatLngExpression, LeafletEventHandlerFnMap, Tooltip as LeafletTooltipInstance, TooltipEvent, TooltipOptions } from '@anlan/gs-map';
import type { EventedProps, LeafletContextInterface } from './core';
import type { SetOpenFunc } from './core/div-overlay';
import type { LeafletElement } from './core/element';
const LeafletTooltip = L.Tooltip;

export interface TooltipProps extends TooltipOptions, EventedProps {
    children?: ReactNode
    position?: LatLngExpression
}

export const Tooltip = createOverlayComponent<LeafletTooltipInstance, TooltipProps>(function createTooltip(props: TooltipProps, context: LeafletContextInterface) {
    const tooltip = new LeafletTooltip(props, context.overlayContainer);
    return createElementObject(tooltip, context);
}, function useTooltipLifecycle(element: LeafletElement<LeafletTooltipInstance>, context: LeafletContextInterface, { position  }: TooltipProps, setOpen: SetOpenFunc) {
    useEffect(function addTooltip() {
        const container = context.overlayContainer;
        if (container == null) {
            return;
        }
        const { instance  } = element;
        const onTooltipOpen = (event: TooltipEvent)=>{
            if (event.tooltip === instance) {
                if (position != null) {
                    instance.setLatLng(position);
                }
                instance.update();
                setOpen(true);
            }
        };
        const onTooltipClose = (event: TooltipEvent)=>{
            if (event.tooltip === instance) {
                setOpen(false);
            }
        };
        const handlers: LeafletEventHandlerFnMap = {
            tooltipopen: onTooltipOpen,
            tooltipclose: onTooltipClose
        };
        container.on(handlers);
        if (container.bindTooltip == null) {
            throw new Error('Overlay container does not support bindTooltip');
        }
        container.bindTooltip(instance);
        return function removeTooltip() {
            container.off(handlers);
            if (container._map != null) {
                if (container.unbindTooltip == null) {
                    throw new Error('Overlay container does not support unbindTooltip');
                }
                container.unbindTooltip();
            }
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});
